// Auspicious Numerology — fun facts about a phone number, shown while waiting for order status.

var THAI_DIGITS = { 0: '\u0E50', 1: '\u0E51', 2: '\u0E52', 3: '\u0E53', 4: '\u0E54', 5: '\u0E55', 6: '\u0E56', 7: '\u0E57', 8: '\u0E58', 9: '\u0E59' };
var KOREAN_DIGITS = { 0: '\uC601', 1: '\uC77C', 2: '\uC774', 3: '\uC0BC', 4: '\uC0AC', 5: '\uC624', 6: '\uC721', 7: '\uCE60', 8: '\uD314', 9: '\uAD6C' };
var JAPANESE_DIGITS = { 0: '\u3007', 1: '\u4E00', 2: '\u4E8C', 3: '\u4E09', 4: '\u56DB', 5: '\u4E94', 6: '\u516D', 7: '\u4E03', 8: '\u516B', 9: '\u4E5D' };
var WORD_DIGITS = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
var NATO_DIGITS = ['zero', 'one', 'two', 'tree', 'fower', 'fife', 'six', 'seven', 'ait', 'niner'];
var MORSE = { 0: '-----', 1: '.----', 2: '..---', 3: '...--', 4: '....-', 5: '.....', 6: '-....', 7: '--...', 8: '---..', 9: '----.' };
// Phone keypad letters — each digit maps to a set of letters, we cycle through per-digit occurrence
var KEYPAD = { 0: ['+'], 1: [''], 2: ['A','B','C'], 3: ['D','E','F'], 4: ['G','H','I'], 5: ['J','K','L'], 6: ['M','N','O'], 7: ['P','Q','R','S'], 8: ['T','U','V'], 9: ['W','X','Y','Z'] };
var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

function digits(phone) {
  return phone.replace(/\D/g, '').split('').map(Number);
}

function groupsOf(phone) {
  return phone.split(/[\s\-.()+]+/).filter(Boolean);
}

function mapDigits(phone, map, sep) {
  return groupsOf(phone).map(function (g) {
    return g.split('').map(function (c) { return /\d/.test(c) ? map[c] : c; }).join('');
  }).join(sep || '-');
}

function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

function isPrime(n) {
  if (n < 2) return false;
  if (n < 4) return true;
  if (n % 2 === 0 || n % 3 === 0) return false;
  for (var i = 5; i * i <= n; i += 6) {
    if (n % i === 0 || n % (i + 2) === 0) return false;
  }
  return true;
}

function largestPrimeSubstring(d) {
  var best = -1;
  for (var len = 1; len <= Math.min(d.length, 9); len++) {
    for (var start = 0; start + len <= d.length; start++) {
      var n = parseInt(d.slice(start, start + len).join(''), 10);
      if (isPrime(n) && n > best) best = n;
    }
  }
  return best > 0 ? best : null;
}

function romanNumeral(n) {
  if (n <= 0 || n > 3999) return String(n);
  var vals = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  var syms = ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I'];
  var result = '';
  for (var i = 0; i < vals.length; i++) {
    while (n >= vals[i]) { result += syms[i]; n -= vals[i]; }
  }
  return result;
}

function commaFormat(n) {
  return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function keypadLetters(d) {
  // Cycle through the keypad letters for each digit independently
  var counters = {};
  return d.map(function (digit) {
    var letters = KEYPAD[digit];
    if (!letters || letters.length === 0) return String(digit);
    if (!counters[digit]) counters[digit] = 0;
    var letter = letters[counters[digit] % letters.length];
    counters[digit]++;
    return letter;
  });
}

function keypadLettersFormatted(phone) {
  var d = digits(phone);
  var letters = keypadLetters(d);
  var groups = groupsOf(phone);
  var result = [];
  var idx = 0;
  for (var g = 0; g < groups.length; g++) {
    var groupLen = groups[g].length;
    result.push(letters.slice(idx, idx + groupLen).join(''));
    idx += groupLen;
  }
  return result.join('-');
}

function dateFromDigits(d) {
  // Try to construct a date from the digits: MM/DD/YYYY or similar
  if (d.length < 8) return null;
  var month = d[0] * 10 + d[1];
  var day = d[2] * 10 + d[3];
  // Use remaining digits for year
  var yearDigits = d.slice(4);
  var year = parseInt(yearDigits.join(''), 10);

  // If month > 12, try single-digit month
  if (month > 12 || month === 0) {
    month = d[0];
    day = d[1] * 10 + d[2];
    yearDigits = d.slice(3);
    year = parseInt(yearDigits.join(''), 10);
  }
  if (month > 12 || month === 0) return null;
  if (day > 31 || day === 0) day = Math.min(day, 28);

  var monthName = MONTHS[month - 1];

  // Build time from remaining digits if we have enough
  var timeStr = '';
  if (d.length >= 10) {
    var h = d[d.length - 4] * 10 + d[d.length - 3];
    var m = d[d.length - 2] * 10 + d[d.length - 1];
    var s = d.length >= 12 ? d[d.length - 6] * 10 + d[d.length - 5] : 0;
    var nonStandard = h > 23 || m > 59 || s > 59;
    var timeParts = String(h) + ':' + String(m).padStart(2, '0');
    if (s > 0 || nonStandard) timeParts += ':' + String(s).padStart(2, '0');
    if (nonStandard) timeParts += ' (non-standard time)';
    timeStr = ', ' + timeParts;
  }

  return monthName + ' ' + day + ', ' + year + timeStr;
}

var US_DEBT_TRILLIONS = 36.2; // approximate 2026

function auspiciousNumerology(phone) {
  var d = digits(phone);
  if (d.length === 0) return [];

  var sum = d.reduce(function (a, b) { return a + b; }, 0);
  var count = d.length;
  var avg = (sum / count).toFixed(1);
  var fullNum = parseInt(d.join(''), 10);

  var results = [];

  // Sum
  results.push({ label: 'Sum', value: String(sum) });

  // Digit count
  results.push({ label: 'Count', value: count + ' digits' });

  // Average
  results.push({ label: 'Average', value: avg });

  // Letters — phone keypad cycling
  results.push({ label: 'Letters', value: keypadLettersFormatted(phone) });

  // Lucky numbers (count of 7s and 8s)
  var luckyCount = d.filter(function (x) { return x === 7 || x === 8; }).length;
  results.push({ label: 'Lucky Numbers Count', value: String(luckyCount) });

  // Largest prime substring
  var prime = largestPrimeSubstring(d);
  if (prime !== null) {
    results.push({ label: 'Largest Prime', value: commaFormat(prime) });
  }

  // As distance
  var miles = fullNum;
  var distDesc = '';
  if (miles < 240000) distDesc = 'less than the distance to the Moon';
  else if (miles < 93000000) distDesc = 'approx. distance within the inner solar system';
  else if (miles < 500000000) distDesc = 'approx. distance from Earth to Jupiter\'s neighborhood';
  else if (miles < 2000000000) distDesc = 'approx. distance from Earth to Saturn';
  else if (miles < 4500000000) distDesc = 'approx. distance from Earth to Neptune';
  else if (miles < 10000000000) distDesc = 'approx. distance from Earth to a point far beyond Neptune';
  else distDesc = 'beyond our solar system';
  results.push({ label: 'As Distance', value: commaFormat(miles) + ' miles (' + distDesc + ')' });

  // Spelled out (lowercase, capitalize first word of each group)
  var spelled = groupsOf(phone).map(function (g) {
    var words = g.split('').map(function (c) { return WORD_DIGITS[parseInt(c, 10)]; });
    words[0] = capitalize(words[0]);
    return words.join(' ');
  }).join(', ');
  results.push({ label: 'Spelled Out', value: spelled });

  // Aviation English (lowercase, capitalize first word of each group)
  var aviation = groupsOf(phone).map(function (g) {
    var words = g.split('').map(function (c) { return NATO_DIGITS[parseInt(c, 10)]; });
    words[0] = capitalize(words[0]);
    return words.join(' ');
  }).join(', ');
  results.push({ label: 'In Aviation English', value: aviation });

  // Thai
  results.push({ label: 'In Thai', value: mapDigits(phone, THAI_DIGITS) });

  // Korean
  results.push({ label: 'In Korean', value: mapDigits(phone, KOREAN_DIGITS) });

  // Japanese
  results.push({ label: 'In Japanese', value: mapDigits(phone, JAPANESE_DIGITS) });

  // Roman numerals — per digit, preserving groups with spaces, groups separated by " - "
  var roman = groupsOf(phone).map(function (g) {
    return g.split('').map(function (c) {
      var n = parseInt(c, 10);
      return romanNumeral(n);
    }).join(' ');
  }).join(' - ');
  results.push({ label: 'In Roman Numerals', value: roman });

  // Hexadecimal — per group
  var hex = groupsOf(phone).map(function (g) {
    return parseInt(g, 10).toString(16).toUpperCase();
  }).join('-');
  results.push({ label: 'Hexadecimal', value: hex });

  // Postal code — check if any group matches a known format
  var postalMatch = 'None found';
  results.push({ label: 'Postal code', value: postalMatch });

  // As dollars
  results.push({ label: 'As Dollars', value: '$' + commaFormat(fullNum) });

  // As debt percentage
  var debtPct = (fullNum / (US_DEBT_TRILLIONS * 1e12) * 100);
  var debtStr = debtPct < 0.001 ? debtPct.toExponential(1) : debtPct.toFixed(3);
  results.push({ label: 'As Debt', value: debtStr + '% of the US National Debt' });

  // Date
  var dateStr = dateFromDigits(d);
  if (dateStr) {
    results.push({ label: 'Date', value: dateStr });
  }

  // PowerBall — use individual digits and natural pairs from the number
  if (d.length >= 6) {
    var pbNumbers = [];
    var i = 0;
    while (pbNumbers.length < 5 && i < d.length) {
      // Try to make a two-digit number if it fits in range 1-69
      var twoDigit = (i + 1 < d.length) ? d[i] * 10 + d[i + 1] : -1;
      if (twoDigit >= 1 && twoDigit <= 69 && pbNumbers.length < 5) {
        pbNumbers.push(twoDigit);
        i += 2;
      } else {
        // Use single digit (at least 1)
        pbNumbers.push(Math.max(1, d[i]));
        i++;
      }
    }
    while (pbNumbers.length < 5) pbNumbers.push(Math.max(1, d[pbNumbers.length % d.length]));
    // PB is last unused digit(s), clamped to 1-26
    var pbVal = i < d.length ? d[i] : d[d.length - 1];
    if (i + 1 < d.length) pbVal = d[i] * 10 + d[i + 1];
    pbVal = Math.max(1, Math.min(26, pbVal));
    results.push({ label: 'PowerBall', value: pbNumbers.join(', ') + ', PB ' + pbVal });
  }

  // Morse code — with group separators
  var morseGroups = groupsOf(phone).map(function (g) {
    return g.split('').map(function (c) { return MORSE[c]; }).join(' ');
  });
  results.push({ label: 'Morse Code', value: morseGroups.join(' - ') });

  // Time to count
  var seconds = fullNum;
  var timeStr = '';
  if (seconds < 60) timeStr = seconds + ' seconds';
  else if (seconds < 3600) timeStr = (seconds / 60).toFixed(1) + ' minutes';
  else if (seconds < 86400) timeStr = (seconds / 3600).toFixed(1) + ' hours';
  else if (seconds < 31536000) timeStr = (seconds / 86400).toFixed(1) + ' days';
  else timeStr = (seconds / 31536000).toFixed(1) + ' years';
  results.push({ label: 'Time to Count', value: 'Approximately ' + timeStr });

  // As time duration
  var durYears = (seconds / 31536000).toFixed(1);
  results.push({ label: 'Time', value: commaFormat(fullNum) + ' seconds (approx. ' + durYears + ' years)' });

  return results;
}

module.exports = auspiciousNumerology;
